<template>
  <ButtonV2
    v-if="
      !userStore.isAuthenticated &&
      !userStore.isAuthenticatedWithExternalService
    "
    size="lg"
    variant="primary"
    class="w-full !border-t-0 uppercase gap-2 font-serif !font-normal justify-between flex items-center self-stretch px-6 py-1"
    data-testid="get-membership-button"
    @click="getMembership"
  >
    <!-- TODO: Remove !important from the ButtonV2 classes: !font-normal -->
    <Coin v-if="!channelStore.isLeaderboardDisabled" :points="500"> </Coin>
    <span class="flex items-center justify-center">
      <span>{{ label }}</span>
    </span>
    <Coin v-if="!channelStore.isLeaderboardDisabled" :points="500"> </Coin>
  </ButtonV2>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user.store";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import {
  EventCategory,
  TrackEventEnum,
} from "@/services/tracking/tracking-types";
import { useTrackingStore } from "@/stores/tracking.store";
import { useChannelStore } from "@/stores/channel.store";
import Coin from "@/components/ui/button/coin.vue";
import ButtonV2 from "@/components/ui/button/button-v2.vue";
import { useMaybeWalletService } from "@/services/wallet/wallet.service";

const userStore = useUserStore();
const channelStore = useChannelStore();
const trackingService = useTrackingStore();
const { t } = useI18n();

const walletService = useMaybeWalletService();
const label = computed(() => {
  const token = walletService.value?.channelWebThreeTokens?.[0];
  if (token) {
    if (channelStore.hasMultipleCommunities) {
      return t("channel.buttons.getMembershipWebThreeWithoutToken");
    }
    return t("channel.buttons.getMembershipWebThree", {
      tokenLabel: token.label,
    });
  }

  return t("channel.buttons.getMembership");
});

function getMembership() {
  userStore.login();
  channelStore.$setGatingExperience(null);
  trackingService.track({
    event: TrackEventEnum.LoginClicked,
    category: EventCategory.Identity,
    metadata: {},
  });
}
</script>
